import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

export default function UsersLineChart({ data }) {
  return (
    <div className="card shadow-sm border-0 h-100">
      <div className="card-body">
        <div className="d-flex justify-content-between mb-3">
          <h6 className="fw-semibold mb-0">Users</h6>
          <select className="form-select form-select-sm w-auto">
            <option>2025</option>
          </select>
        </div>

        <ResponsiveContainer width="100%" height={170}>
          <LineChart data={data}>
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="active" stroke="#28a745" />
            <Line type="monotone" dataKey="inactive" stroke="#adb5bd" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}